import { PreferenceStates } from '../reducers/preference.reducer';
import useSelector from './useSelector';

export const usePreferences = (): PreferenceStates =>
  useSelector(state => state.preference);
